import React, { useState } from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useLangTranslation from "../../../../../customHooks/languageProvider";
import { useDispatch } from "react-redux";
import * as authActions from "../../../../AxiosRtk/Auth";
import { setter, getter } from "../../../../../../utils/storage";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getSession, removeSession } from "../../../../../../utils/session";
import { setShowMessage, setErrorInfo } from "../../../../AxiosRtk/successMessage";
import useCrypto from "../../../../../customHooks/crypto";

const EnterPinCode = () => {
  const dispatch = useDispatch();
  const [pin, setPin] = useState({ value: "", error: "" });
  const [pwdType, setPwdType] = useState("password");
  const { getLangTranslation } = useLangTranslation();
  const { decryptRequest } = useCrypto();
  const { setUser } = authActions;

  const sessionUserData = getSession("kidoProtectUser");
  const localStorageUserData = getter("kidoProtectUser");

  const getSessionUser = sessionUserData
    ? JSON.parse(decryptRequest(sessionUserData))
    : null;
  const localStorageData = localStorageUserData
    ? JSON.parse(decryptRequest(localStorageUserData))
    : null;

  const history = useHistory();

  function handleInputChange(e) {
    const { value } = e.target;
    if (isNaN(value)) {
      setPin({
        value: pin?.value,
        error: "SHOULD_BE_NUMBER",
      });
    } else {
      setPin({
        value,
        error: "",
      });
    }
  }

  function formValidate() {
    let flag = true;
    if (isEmpty(pin?.value)) {
      setPin({
        ...pin,
        error: "PINCODE_IS_REQUIRED",
      });
      flag = false;
    } else if (pin?.value?.length !== 4) {
      setPin({
        ...pin,
        error: "EMERGENCY_PIN_PIN_LENGTH_SHOULD_BE_4",
      });
      flag = false;
    }

    return flag;
  }

  function handleTogglePassword() {
    setPwdType(pwdType === "password" ? "text" : "password");
  }

  function handleNext() {
    if (!formValidate()) {
      return;
    }

    const loginPin = getSessionUser
      ? getSessionUser?.loginPin
      : localStorageData?.loginPin;

    if (loginPin === (pin?.value)) {
      dispatch(
        setShowMessage({
          showMessage: true,
          defaultMessage: "Successful login",
          message: "LOGIN_SUCCESS",
        })
      );

      dispatch(setUser(getSessionUser));

      setter("kidoProtectUser", sessionUserData);
      setter("kidoProtectUserAccessToken", getSessionUser ? getSessionUser?.accessToken : localStorageData?.accessToken);

      removeSession("kidoProtectUser");
      removeSession("kidoProtectUserAccessToken");

      history.push("/dashboard");

    } else {
      dispatch(setErrorInfo({
        errorInfo: true,
        title: "PINCODE_INCORRECT",
        defaultTitle: "Please enter a valid PIN CODE"
      }));
    }
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      handleNext();
    }
  }

  return (
    <div className="container">
      <div className="auth-wrapper">
        <div className="auth-inner">
          <h2 className="text-center mb-3 auth-sub-title">
            {getLangTranslation(
              "ENTER_YOUR_PIN_CODE_TITLE",
              "Enter your Pin Code"
            )}
          </h2>
          <p className="text-center mb-6 light-text">
            {getLangTranslation(
              "ENTER_YOUR_REGISTERED_PIN_CODE",
              "Please enter your registered Pin Code"
            )}
          </p>
          <div className="mb-3">
            <form>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType}
                  name="pincode"
                  placeholder="Pin Code"
                  maxLength={4}
                  value={pin?.value}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword()}
                >
                  {pwdType === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {pin?.error && (
                <label className="field-error">
                  {getLangTranslation(pin?.error)}
                </label>
              )}
            </form>
          </div>
          <div className="text-end mb-6">
            <Link to="/auth/forget-pin-code">
              {getLangTranslation(
                "ENTER_YOUR_PIN_CODE_FORGOT_YOUR_CODE",
                "Forgot Your Code?"
              )}
            </Link>
          </div>
          <div className="d-grid">
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleNext}
            >
              <span className="btn-upper-case">
                {getLangTranslation("ENTER_YOUR_PIN_CODE_NEXT", "Next")}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnterPinCode;
